module.exports = __webpack_public_path__ + "img/CDNX-logo_small_dark.848327.png";